module.exports = __webpack_public_path__ + "img/poster-theme.924a975b.jpg";